import { AssetImageType, IAssetImageModel } from "@xala/common-services";
import { ImageWithPlaceholder, Tag, Title } from "@xala/common-ui";
import cx from "classnames";
import React from "react";
import { IListItemComponentPreviewProps } from "./ListItemComponentPreview";
import "./ListItemHighlightComponentPreview.scss";

export interface IListItemHighlightComponentPreviewProps
  extends IListItemComponentPreviewProps {}

export class ListItemHighlightComponentPreview extends React.Component<
  IListItemHighlightComponentPreviewProps
> {
  public static defaultProps: IListItemHighlightComponentPreviewProps = {
    isPlaceholder: false,
    width: 0,
  };

  public render() {
    const { asset, isHovered, placeholderSrc } = this.props;

    let frameImageUrl: string | undefined = "";
    let title: string | undefined = "";

    if (asset && asset.Images) {
      let assetFrameImage = asset.Images.find(
        (row: IAssetImageModel) =>
          row.AssetImageTypeCode === AssetImageType.Highlights
      );

      if (!assetFrameImage) {
        assetFrameImage = asset.Images.find(
          (row: IAssetImageModel) =>
            row.AssetImageTypeCode === AssetImageType.Frame
        );
      }

      if (assetFrameImage) {
        frameImageUrl = assetFrameImage.Url;
        title = asset.Title;
      }
    }

    return (
      <div
        className={cx("ListItemHighlightComponentPreview", {
          "ListItemHighlightComponentPreview--active": isHovered,
        })}
      >
        <ImageWithPlaceholder
          animated={true}
          imageSrc={frameImageUrl}
          imageContainerClassName="ListItemHighlightComponentPreview--image"
          placeholderSrc={placeholderSrc}
        />
        <div className="ListItemHighlightComponentPreview--info">
          <Tag color="#e933b3" className="tag">
            Gonzo exclusive
          </Tag>
          <Title className="title" level={2}>
            {title}
          </Title>
        </div>
      </div>
    );
  }
}
